import { useParams, Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ArrowRight, CheckCircle2 } from "lucide-react";

const CITY_NAMES = {
  "praha": "Praha", "brno": "Brno", "ostrava": "Ostrava",
  "plzen": "Plzeň", "liberec": "Liberec", "olomouc": "Olomouc",
  "hradec-kralove": "Hradec Králové", "ceske-budejovice": "České Budějovice",
};

const CityLanding = () => {
  const { slug } = useParams();
  const city = CITY_NAMES[slug] || slug;

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <section className="grain-bg py-20">
          <div className="container-page">
            <div className="tiny-label mb-3">Pranidomu.cz · {city}</div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.05] max-w-3xl">
              Praní prádla {city} <span className="text-sky-600">přímo z vašeho bytu</span>.
            </h1>
            <p className="mt-6 text-lg text-slate-600 max-w-2xl">
              Pohodlné vyzvednutí, profesionální praní, doručení zpět – vše za {city === "Praha" ? "1–2 dny" : "2 dny"}.
              Ověřené prádelny ve městě {city} a pevné ceny od 60 Kč / kg.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to={`/registrace?role=customer&city=${encodeURIComponent(city)}`} className="cta-primary" data-testid={`city-cta-order-${slug}`}>
                Objednat praní v {city} <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to={`/pradelny?city=${encodeURIComponent(city)}`} className="cta-ghost" data-testid={`city-cta-providers-${slug}`}>
                Prohlédnout prádelny v {city}
              </Link>
            </div>
          </div>
        </section>

        <section className="container-page py-16">
          <h2 className="font-display text-3xl font-bold mb-8">Proč Pranidomu.cz {city}?</h2>
          <div className="grid md:grid-cols-3 gap-5">
            {[
              `Lokální prádelny ${city}, žádné anonymní řetězce.`,
              "Transparentní ceny 60–120 Kč / kg včetně dopravy.",
              "Fotodokumentace každého pytle – nic se neztratí.",
              "Hodnocení zákazníků a kontrola kvality.",
              "Eco a hypoalergenní praní na vyžádání.",
              "Možnost dary 50 Kč na praní pro seniora.",
            ].map((t) => (
              <div key={t} className="flex items-start gap-3 p-5 rounded-xl bg-white border border-slate-200">
                <CheckCircle2 className="w-5 h-5 text-emerald-600 mt-0.5 flex-shrink-0" />
                <p className="text-slate-700">{t}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-white border-y border-slate-200">
          <div className="container-page py-16">
            <h2 className="font-display text-3xl font-bold mb-4">Často kladené otázky – praní prádla {city}</h2>
            <div className="grid md:grid-cols-2 gap-6 mt-6">
              <div>
                <h3 className="font-semibold text-slate-900 mb-1">Jak rychle prádelna vyzvedne prádlo?</h3>
                <p className="text-slate-600 text-sm">Obvykle do 24 hodin v {city}. S expresem same-day i během několika hodin.</p>
              </div>
              <div>
                <h3 className="font-semibold text-slate-900 mb-1">Kolik stojí praní 10 kg?</h3>
                <p className="text-slate-600 text-sm">Standard 600 Kč, Premium s žehlením 800 Kč. Bez skrytých poplatků.</p>
              </div>
              <div>
                <h3 className="font-semibold text-slate-900 mb-1">Co když se prádlo poškodí?</h3>
                <p className="text-slate-600 text-sm">Objednávky přes platformu mají pojištění a systém řešení sporů.</p>
              </div>
              <div>
                <h3 className="font-semibold text-slate-900 mb-1">Můžu mít vlastní preference (eco, hypoalerg.)?</h3>
                <p className="text-slate-600 text-sm">Ano, v objednávce vyberete preference a prádelna se podle nich řídí.</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CityLanding;
